import axios from 'axios'
import Constantes from '../../utils/constantes'
import Alert from '../../utils/alert'
import router from '../../router/index'

const state = {
}

// getters
const getters = {
}

// actions
const actions = {
  alterarusuario({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('core/setLoading', true, { root: true })
      commit('core/clearError', null, { root: true })
      axios({
        method: 'POST',
        url: Constantes.URL_SERVIDOR + '/b2cusuario/save',
        data: payload
      }).then(
        result => {
          // console.log(result.data)
          resolve(result.data);
          commit('core/setSuccess', { message: 'Atualização realizada com sucesso.' }, { root: true })
          commit('core/setLoading', false, { root: true })
        },
        error => {
          // console.error(error)
          commit('core/setLoading', false, { root: true })
          commit('core/setError', { message: 'Erro' }, { root: true })
          reject(error);
        }
      )
    })
  },
}

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
